import { render } from "./HeroiconsSolidCake.vue?vue&type=template&id=68ecf852"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCake.vue"]])

export default __exports__